import {Component, OnInit} from '@angular/core';
import {TicketModel} from '@app/models/ticket';
import {CourseModel} from '@app/@core/domain/course.model';
import {HomeConfigRepository} from '@app/@core/repositories/home-config-repository.service';
import {MenuItem, SelectItem} from 'primeng/api';
import {RouteStateService} from '@app/@core/services/route-state.service';
import {AppService} from '@shared/services/app.service';
import {SectionEditDialogComponent} from '@app/modules/app-config/components/section-edit-dialog/section-edit-dialog.component';
import Ticket = TicketModel.Ticket;
import Course = CourseModel.Course;
import {SectionModel} from '@app/models/section';
import HomeConfig = SectionModel.HomeConfig;
import SectionType = SectionModel.SectionType;
import Section = SectionModel.Section;
import {TicketService} from '@app/@core/services/ticket.service';

@Component({
    templateUrl: './home-config-detail.component.html',
    styleUrls: ['./home-config-detail.component.css'],
})
export class HomeConfigDetailComponent implements OnInit {
    homeConfig: HomeConfig;

    selectTypes: SelectItem[] = ['MENU', 'CAROUSEL', 'BANNER', 'BUCKET', 'COVER'].map(v => ({label: v, value: v}));

    items: MenuItem[] = [
        {label: 'Publish', icon: 'pi pi-caret-right', command: () => this.publish()},
        {label: 'Clone', icon: 'pi pi-clone', command: () => this.cloneEntity()},
        {label: 'Delete', icon: 'pi pi-times', command: () => this.deleteEntity()}
    ];

    fileContent: string;

    typeOptions: SelectItem[] = [
        {label: 'HOME', value: 'HOME'},
        {label: 'HOTDEAL', value: 'HOTDEAL'},
        {label: 'HOME_JP', value: 'HOME_JP'},
        {label: 'COURSE', value: 'COURSE'},

        {label: 'CAMPAIGN', value: 'CAMPAIGN'},
        {label: 'SPECIAL_CAMPAIGN', value: 'SPECIAL_CAMPAIGN'},
        {label: 'COO_CAMPAIGN', value: 'COO_CAMPAIGN'},
        {label: 'PACKAGE', value: 'PACKAGE'},
        {label: 'TICKET', value: 'LEISURE'},
    ];

    liveOptions: SelectItem[] = [
        {label: 'Live', value: true},
        {label: 'Draft', value: false},
    ];

    constructor(
        private app: AppService,
        private homeConfigRepository: HomeConfigRepository,
        private ticketService: TicketService,
        private routeStateService: RouteStateService) {
    }

    ngOnInit() {
        const id = this.routeStateService.getCurrent().data.id;

        if (id === 'new') {
            this.newHome();
        } else {
            this.homeConfigRepository.get(id).subscribe(v => {
                this.homeConfig = v;
            });
        }


        this.ticketService.fetchAllName().subscribe();
    }

    newHome() {
        this.homeConfig = {sections: []} as HomeConfig;
    }

    goBack() {
        this.routeStateService.loadPrevious();
    }

    cloneEntity() {
        this.app.confirm('Clone and edit', () => {
            this.homeConfig = {
                ...this.homeConfig,
                ...{
                    id: null,
                    name: `${this.homeConfig.name}-CLONE`,
                    live: false,
                    note: '',
                    liveDate: null
                } as HomeConfig
            };
        });
    }

    openEditDialog(section: SectionModel.Section, index: number) {
        this.app.showDialog(SectionEditDialogComponent, 'Edit Section', {
            section: {...section}
        }, {
            'min-width': '80%',
            'min-height': '80%',
        }).onClose.subscribe((modifiedSection) => {
            if (modifiedSection) {
                if (index !== -1) {
                    this.homeConfig.sections[index] = modifiedSection;
                } else {
                    this.homeConfig.sections = [
                        ...this.homeConfig.sections,
                        modifiedSection
                    ];
                }
            }
        });
    }

    deleteItem(index: number) {
        this.homeConfig.sections.splice(index, 1);
    }

    saveEntity() {
        this.app.confirmSave(() => {
            this.homeConfigRepository.upsert(this.homeConfig).subscribe(hc => {
                this.homeConfig = hc;
                this.app.toastSuccess('Saved');
            });
        });
    }

    deleteEntity() {
        this.app.confirmDelete('', () => {
            this.homeConfigRepository.delete(this.homeConfig.id)
                .subscribe(arg => this.goBack());
        });
    }

    publish() {
        this.app.confirm('Publish', () => {
            this.homeConfig.live = true;
            this.homeConfigRepository.publish(this.homeConfig.id).subscribe(hc => {
                this.homeConfig = hc;
                this.app.toastSuccess('Published');
            });
        });
    }

    saveToFile(section: Section) {
        this.app.showTextInputDialog('File name', 'File name').onClose.subscribe(result => {
            if (result.value) {
                this.app.saveToFile(JSON.stringify(section, null, 2), `${section.type}-${result.value}.json`);
            }
        });
    }

    addNewSection(type: SectionType) {
        this.openEditDialog({type, cards: []}, -1);
    }

    addNewSectionFromFile() {
        this.openEditDialog(JSON.parse(this.fileContent), -1);
    }

    handleFileInput(event: Event) {
        const fileList: FileList = event.target['files'];
        if (fileList.length > 0) {
            const file = fileList[0];

            const fileReader: FileReader = new FileReader();
            const self = this;
            fileReader.onloadend = () => {
                self.fileContent = fileReader.result as string;
            };

            fileReader.readAsText(file);
        }
    }
}
